import { IconProps } from './index';

const VideoCamera = ({ title, titleId, ...props }: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="15"
            height="12"
            viewBox="0 0 15 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M10.8333 4.13341L14.3086 1.70008C14.3586 1.66505 14.4172 1.64441 14.4781 1.64042C14.539 1.63642 14.5998 1.64921 14.654 1.67741C14.7081 1.70561 14.7534 1.74812 14.7851 1.80032C14.8167 1.85251 14.8334 1.91239 14.8333 1.97341V10.0267C14.8334 10.0878 14.8167 10.1477 14.7851 10.1998C14.7534 10.252 14.7081 10.2946 14.654 10.3228C14.5998 10.3509 14.539 10.3637 14.4781 10.3597C14.4172 10.3557 14.3586 10.3351 14.3086 10.3001L10.8333 7.86675V10.6667C10.8333 10.8436 10.7631 11.0131 10.638 11.1382C10.513 11.2632 10.3434 11.3334 10.1666 11.3334H0.833293C0.656482 11.3334 0.486912 11.2632 0.361888 11.1382C0.236864 11.0131 0.166626 10.8436 0.166626 10.6667V1.33341C0.166626 1.1566 0.236864 0.987035 0.361888 0.86201C0.486912 0.736986 0.656482 0.666748 0.833293 0.666748H10.1666C10.3434 0.666748 10.513 0.736986 10.638 0.86201C10.7631 0.987035 10.8333 1.1566 10.8333 1.33341V4.13341ZM10.8333 6.23941L13.5 8.10608V3.89341L10.8333 5.76008V6.23941ZM1.49996 2.00008V10.0001H9.49996V2.00008H1.49996Z"
                fill="white"
            />
        </svg>
    );
};

export default VideoCamera;
